import React, { FC, useEffect, useMemo, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import { LayoutSpinner } from './App.styled';
import { SpinnerWidgetContainer } from '@prometheus/features';

import { Welcome } from './components/Welcome';
import { PrivateRoute } from './components/PrivateRoute';
import { AppLayout } from './components/AppLayout';
import { modulesSideNavigation } from './app.config';
import { useTranslation } from 'react-i18next';

import './styles.css';
import './fonts.css';
import { ModalProvider } from '@prometheus/hooks';

export const App: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { t } = useTranslation();

  const modules = useMemo(() => modulesSideNavigation(t), [t]);

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  if (isLoading) {
    return (
      <SpinnerWidgetContainer>
        <LayoutSpinner size={70} />
      </SpinnerWidgetContainer>
    );
  }

  return (
    <Routes>
      <Route path="/*" element={<PrivateRoute />}>
        <Route
          element={
            //  should be inside Private route container, so it disappear after logout
            <ModalProvider>
              <AppLayout modulesSideNavigation={modules} />
            </ModalProvider>
          }
        >
          <Route
            index
            element={
              <Welcome modulesSideNavigation={modules} subModulesLoad={[]} />
            }
          />

          {modules.map((mod: any) => {
            const { component: Component, ...rest } = mod;
            return (
              <Route
                path={`${rest.path}/*`}
                key={rest.name}
                element={<Component t={t} {...rest} />}
              />
            );
          })}
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
